import { render } from "./ResumoPedido.vue?vue&type=template&id=274632ac&scoped=true"
import script from "./ResumoPedido.vue?vue&type=script&lang=js"
export * from "./ResumoPedido.vue?vue&type=script&lang=js"

import "./ResumoPedido.vue?vue&type=style&index=0&id=274632ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274632ac"]])

export default __exports__